/**
 * @file Generate new initial draft state
 */

import { DraftDataFormatted } from '../models/draft';

/**
 * Generate new initial draft state
 *
 * @param parentId What the draft is for
 * @param topicId  The topic ID to use for the draft
 * @returns        The state to use
 */
const stateDraftsInitDraft = (
  parentId: string,
  topicId?: string,
): DraftDataFormatted => ({
  assigneeGroupsCurrent: new Set(),
  assigneeGroupsSaved: new Set(),
  assigneeMembersCurrent: new Set(),
  assigneeMembersSaved: new Set(),
  assigneeSearch: '',
  checklistCurrent: [],
  checklistSaved: [],
  dataLabelsMode: 'VIEW',
  dateDueCurrent: null,
  dateDueSaved: null,
  labelCurrentId: null,
  labelsCurrent: new Set(),
  labelsSaved: new Set(),
  labelsSearch: '',
  nodeId: null,
  offsetCurrent: null,
  offsetSaved: null,
  parentId,
  remindersCurrent: [],
  remindersSaved: [],
  status: null,
  templateCurrent: null,
  templateSaved: null,
  templateSearch: '',
  templateTopicCurrent: topicId ?? null,
  templateTopicSaved: topicId ?? null,
  templateTopicSearch: '',
  text: '',
  title: '',
});

export default stateDraftsInitDraft;
